import { render, staticRenderFns } from "./scene-view.vue?vue&type=template&id=13c35101&"
import script from "./scene-view.vue?vue&type=script&lang=js&"
export * from "./scene-view.vue?vue&type=script&lang=js&"
import style0 from "./scene-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports